import React from "react"
import { useLocation } from "wouter"

export function Footer() {
  const [location, navigate] = useLocation()

  return (
    <footer className="footer">
      <div className="footer-orange">
        <a
          href="/lets-work-together"
          className="footer-tagline"
          onClick={e => { e.preventDefault(); navigate("/lets-work-together") }}
        >
          get in touch and start<br />discussing your project today
        </a>
        <div className="footer-wordmark">Present</div>
        <div className="footer-bottom">
          <span className="footer-copy">© Present Future Limited · 2026</span>
          <a
            href="/lets-work-together"
            className="footer-cta"
            onClick={e => { e.preventDefault(); navigate("/lets-work-together") }}
          >
            get in touch →
          </a>
        </div>
      </div>
    </footer>
  )
}
